module.exports = __webpack_public_path__ + "147ae4e96bafa2fdd9843d2286228935.obj";